import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

@Component({
    template: `<div>This component requires extending</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListsComponent implements OnInit {
    @Input() public limit: number = null;
    @Input() public placeholders: number = 6;
    @Input() public loading: boolean = false;

    public emptyPlaceholders: any[] = [1, 2, 3, 4, 5, 6];
    public searchTerm$: Observable<string>;

    constructor() { }

    ngOnInit(): void {
        this.emptyPlaceholders = new Array(this.placeholders);
    }
}
